import React from 'react';
import ReactDOM from 'react-dom';
import './style.sass';

function Modal({...props}){
    const {
        children,
        onClose,
        type,
        closeBody,
        title
    } =props

    return(
        closeBody !== "closeBody"
            ?
                <div className={`modal ${type}`}>
                    <div className="contentModal" >
                        {type === "fullHeader"
                            ? null
                            :
                                <div className="contentClose">
                                    <div className="btn close" onClick={onClose}></div>
                                    {title ? <p className="title">{title}</p> : null }
                                </div>
                        }        
                        <div className="dataModal">
                            {children}
                        </div>
                    </div>
                </div>
            :
                <div className={`modal ${type}`} onClick={onClose}>
                    <div className="contentModal">
                        {type === "fullHeader"
                            ? null
                            :
                                <div className="contentClose">
                                    <div className="btn close" onClick={onClose}></div>
                                    {title ? <p className="title">{title}</p> : null }
                                </div>
                        }        
                        <div className="dataModal">
                            {children}
                        </div>
                    </div>
                </div>
            
    )
}

export default function ModalPortal ({...props}){
    const {
        children,
        onClose,
        type,
        closeBody,
        title
    } = props

    return ReactDOM.createPortal(
        <Modal onClose={onClose} type={type} title={title} closeBody={closeBody}>
            {children}
        </Modal>,
        document.getElementById('modal-root')
    )
}